<template>
  <div class="dataset">
    <div class="filter-dataset">
      <div class="workspaces-count-sort d-flex flex-column flex-md-row">
        <div
          class="workspaces-count overflow-hidden pr-md-4 flex-grow-1 full-width"
        >
          <div class="text-truncate full-width">
            <span v-if="emtySelected">{{ $t('datastore.layer.title') }}</span>
            <template v-else>
              <strong>{{
                (items ? items.length : 0) +
                  ' ' +
                  $t('datastore.layer.title') +
                  ' '
              }}</strong>
              <span class="">
                {{ `${$t('datastore.layer.in')} ${selected.name}` }}</span
              >
            </template>
          </div>
        </div>
        <div class="d-flex flex-grow-0">
          <v-text-field
            v-model="params.search"
            clearable
            dense
            hide-details
            outlined
            placeholder="Tìm kiếm theo tên"
            prepend-inner-icon="mdi-magnify"
            single-line
            background-color="#fff"
          />
        </div>
      </div>
    </div>
    <div class="d-flex align-center justify-center" v-if="loading">
      <v-progress-linear indeterminate></v-progress-linear>
    </div>
    <template>
      <div v-if="emtySelected" class="bd_extension text-center">{{
        $t('datastore.layer.emptySelected')
      }}</div>
      <div v-else-if="!selected.enabled" class="bd_extension">
        <i18n path="datastore.sourceIsDisabled">
          <template v-slot:Enable>
            <a @click="onEnableDataStore()">{{ $t('datastore.enable') }}</a>
          </template>
        </i18n>
      </div>
      <div v-else class="dataset-list">
        <div class="dataset-item" v-for="item in layers" :key="item.id">
          <div>
            <strong class="dataset-item-title" :title="item.name">{{
              item.name
            }}</strong>
            <base-button-group
              class="float-right mr-2"
              :items="menus"
              :value="item"
            ></base-button-group>
          </div>

          <div class="d-flex align-center">
            <div v-if="item.is_publish">
              <span class="primary--text d-inline-block" style="width: 100px">
                {{ $t('datastore.layer.publish') }}
              </span>
              <v-btn
                depressed
                small
                desen
                class="text-none"
                height="25px"
                style="margin-left: 10px; font-size: 0.75rem"
                @click="goPublish(item)"
                :disabled="loading"
              >
                <span>Tái {{ $t('datastore.layer.publish') }}</span>
                <v-icon right small>mdi-arrow-right</v-icon>
              </v-btn>
            </div>

            <div v-else class="d-flex align-center">
              <span class="d-inline-block" style="width: 100px">
                {{ $t('datastore.layer.unpublish') }}
              </span>
              <v-btn
                depressed
                small
                desen
                height="25px"
                class="text-none"
                style="margin-left: 10px; font-size: 0.75rem"
                @click="goPublish(item)"
                :disabled="loading"
              >
                <span>{{ $t('datastore.layer.publish') }}</span>
                <v-icon right small>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </template>
    <congbodialog ref="dialog" @reset="fetchData()" />
    <DetailField ref="dialogDetailField" :id="id" />
    <DetailFeature ref="dialogDetailData" :id="id" :fields="fields" />
    <DetailInfo
      ref="dialogDetailInfo"
      :fields="fields"
      :features_count="features_count"
      @reset="onReset"
    />
  </div>
</template>
<script>
import { API_DATASTORE } from '@api'
import congbodialog from './congbodialog.vue'
import DetailFeature from './datastore-detail-item/feature.vue'
import DetailField from './datastore-detail-item/field.vue'
import DetailInfo from './datastore-detail-item/detail-info.vue'
import { EDIT_TYPE } from '@constant'
import { sdk } from '@service/http/axios'
import { saveAs } from 'file-saver'

export default {
  components: {
    congbodialog,
    DetailField,
    DetailFeature,
    DetailInfo,
  },
  props: {
    selected: { type: Object, default: () => ({}) },
  },

  data: (vm) => ({
    fields: [],
    features_count: 0,
    params: { search: null },
    items: [],
    loading: false,
    id: 0,
    menus: [
      {
        icon: 'mdi-information-outline',
        title: 'Thông tin bộ dữ liệu',
        handler: (item) => vm.openDetailInfoDialog(item),
      },
      {
        icon: 'mdi-information-outline',
        title: 'Trường dữ liệu',
        handler: (item) => vm.openDetailFieldDialog(item),
        hide: (item) => {
          return ['tif', 'pdf'].includes(item.type)
        },
      },
      {
        icon: 'mdi-information-outline',
        title: 'Dữ liệu',
        handler: (item) => vm.openDetailFeatureDialog(item),
        hide: (item) => {
          return ['tif', 'pdf'].includes(item.type)
        },
      },
      {
        icon: 'mdi-microsoft-excel',
        title: vm.$t('layer.action.export'),
        handler: (item) => vm.onExportExcel(item),
        hide: (item) => {
          return ['tif', 'pdf'].includes(item.type)
        },
      },
    ],
  }),
  computed: {
    emtySelected() {
      return (
        !this.selected ||
        (Object.keys(this.selected).length === 0 &&
          Object.getPrototypeOf(this.selected) === Object.prototype)
      )
    },
    layers() {
      let result = this.items.slice()
      if (this.params.search) {
        result = result.filter((x) =>
          x.name.toLowerCase().includes(this.params.search.toLowerCase())
        )
      }
      return result
    },
  },
  watch: {
    selected(val) {
      this.items = []
      if (val && val.enabled && val != {} && val.workspace_id && val.id) {
        this.fetchData()
      }
    },
  },
  methods: {
    onEnableDataStore() {
      this.$emit('click:enabled', this.selected)
    },
    fetchData() {
      this.loading = true
      API_DATASTORE.getDetail(this.selected.id)
        .then((res) => {
          this.items = res.data.details
        })
        .finally(() => {
          this.loading = false
        })
    },
    goPublish(item) {
      this.$refs.dialog.open(item, EDIT_TYPE.CREATE)
    },
    openDetailFieldDialog(item) {
      this.id = item.id
      this.$refs.dialogDetailField.open(item)
    },
    async openDetailFeatureDialog(item) {
      this.id = item.id
      const res = await sdk.request({
        url: `datastore-details/${this.id}/fields`,
        method: 'get',
      })
      this.fields = res.data
      this.$refs.dialogDetailData.open(item)
    },
    async openDetailInfoDialog(item) {
      let itemDialog = { ...item }
      this.id = itemDialog.id
      if (['shapefile', 'api'].includes(item.type)) {
        const res = await sdk.request({
          url: `datastore-details/${this.id}/get-detail`,
          method: 'get',
        })
        this.fields = res.data.data.fields
        this.features_count = res.data.data.features_count
      }
      this.$refs.dialogDetailInfo.open(itemDialog)
    },
    async onExportExcel(item) {
      const res = await sdk.request({
        url: `datastore-details/export-excel/${item.id}`,
        method: 'get',
        responseType: 'blob',
      })
      if (res && res.status == 200) {
        saveAs(new Blob([res.data]), `${item.name}.xlsx`)
      }
    },
    onReset() {
      this.fetchData()
    },
  },
}
</script>

<style scoped lang="scss">
$border: #dadbdc;
$background: #dadce0;
.dataset {
  border: 1px solid $border;
  border-bottom: none;
  border-radius: 4px;
  .filter-dataset {
    background-color: $background;
    font-size: 13px;
    padding: 4px 10px 4px 10px;
    input {
      font-size: 11px;
    }
    .filter-select {
      align-items: center;
      padding-right: 10px;
      margin-right: 10px;
    }
    .sort-label {
      height: fit-content;
      width: 55px;
    }
    .workspaces-count {
      height: fit-content;
      div {
        height: fit-content;
      }
    }
    .workspaces-count-sort,
    .filter-select {
      align-items: center;
    }
  }
  .dataset-item {
    border-bottom: 1px solid $border;
    padding: 8px;
    div {
      &:first-child {
        margin-bottom: 10px;
      }
    }
    .dataset-item-title {
      white-space: nowrap;
      overflow: hidden;
      width: 100%;
      text-overflow: ellipsis;
      display: inline-block;
    }
  }
}
.bd_extension {
  border-bottom: 1px solid #dadbdc;
  padding: 10px;
}
.atag {
  color: var(--v-primary-base) !important;
}
.atag:hover {
  text-decoration: underline !important;
}
</style>
